import { render, staticRenderFns } from "./ReportMedication.vue?vue&type=template&id=f70eda1c&scoped=true&"
import script from "./ReportMedication.vue?vue&type=script&lang=js&"
export * from "./ReportMedication.vue?vue&type=script&lang=js&"
import style0 from "./ReportMedication.vue?vue&type=style&index=0&id=f70eda1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70eda1c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VContainer,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1532393991/src/playtient-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f70eda1c')) {
      api.createRecord('f70eda1c', component.options)
    } else {
      api.reload('f70eda1c', component.options)
    }
    module.hot.accept("./ReportMedication.vue?vue&type=template&id=f70eda1c&scoped=true&", function () {
      api.rerender('f70eda1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/ReportMedication.vue"
export default component.exports